import { i18n } from 'i18n/routingUtil';
import { getPageConfigs } from 'utils/marketExtensionConfig';

const patternToRegex = (pattern: string) => {
  const regexStr = pattern
    .replace(/\[\[\.\.\.(.+?)\]\]/g, '(.*)?') // [[...param]]
    .replace(/\[\.\.\.(.+?)\]/g, '(.+)') // [...param]
    .replace(/\[(.+?)\]/g, '([^/]+)'); // [param]
  return new RegExp(`^${regexStr}$`);
};

const removeLocale = (pathname: string, locale: string) => {
  if (locale === i18n().defaultLocale) {
    return pathname;
  }
  const parts = pathname.split('/').filter((part) => part !== '');
  return `/${(parts[0] === locale ? parts.slice(1) : parts).join('/')}`;
};

const getPatternSpecificity = (pattern: string): number => {
  const segments = pattern.split('/');
  let score = 0;

  for (const segment of segments) {
    if (!segment.includes('[')) {
      score += 3;
    } // static segments
    else if (segment.startsWith('[') && segment.includes('...')) {
      score += 1;
    } // catch-all
    else {
      score += 2;
    } // dynamic [param]
  }

  return score;
};

const getRouteFromPathname = (pathname: string, locale: string): keyof typeof pageConfigs => {
  const pageConfigs = getPageConfigs()?.pageConfigs ?? {};

  let normalizedPath = removeLocale(pathname, locale)
    .split('/')
    .filter((part) => part !== '')
    .join('/');

  normalizedPath = ['/', ''].includes(normalizedPath) ? '[userType]' : normalizedPath;

  const pathPatterns = Object.keys(pageConfigs);

  const sortedPatterns = [...pathPatterns].sort((a, b) => getPatternSpecificity(b) - getPatternSpecificity(a));

  for (const pattern of sortedPatterns) {
    const regex = patternToRegex(pattern);
    if (regex.test(normalizedPath)) {
      return pattern as keyof typeof pageConfigs;
    }
  }

  return '' as keyof typeof pageConfigs;
};

export default getRouteFromPathname;
